import { Link, Navigate, useNavigate } from 'react-router-dom'
import AuthForm from '../components/AuthForm'
import { useAuth } from '../context/AuthContext'

function LoginPage() {
  const { user, login } = useAuth()
  const navigate = useNavigate()

  const destination = (account) => (account.profileLevel >= 3 ? '/code' : '/onboarding')

  if (user) {
    return <Navigate to={destination(user)} replace />
  }

  const handleSubmit = async (email, password) => {
    const account = await login(email, password)
    navigate(destination(account))
  }

  return (
    <AuthForm
      title="Log in"
      submitLabel="Log in"
      onSubmit={handleSubmit}
      footer={
        <>
          No account? <Link to="/signup">Sign up</Link>
        </>
      }
    />
  )
}

export default LoginPage
